import { Component, Input } from '@angular/core';
import { Breakpoints } from '../../classes/breakpoints.class';
import { Router } from '@angular/router';

@Component({
  selector: 'app-procedures-list',
  templateUrl: './procedures-list.component.html',
  styleUrls: ['./procedures-list.component.scss'],
})
export class ProceduresListComponent {
  @Input() public list: any;

  public limit: number = 5;
  public pageLimit: number = 10;
  public page: number = 1;
  public expanded: boolean = false;
  public referrer: any;

  constructor(public breakpoints: Breakpoints, private router: Router) {}

  public trackByFn(index, item): number {
    return item.primary_procedure_id;
  }

  public handleSelect(procedureId: number): void {
    this.router.navigate(['/carepath', procedureId, 'preview'], {
      queryParamsHandling: 'preserve',
    });
  }

  public handlePagination(pageNumber: number): void {
    this.page = pageNumber;
  }

  public toggleExpand(): void {
    this.expanded = !this.expanded;
    if (this.limit === this.pageLimit) {
      this.limit = 5;
    } else {
      this.limit = this.pageLimit;
    }
  }

  public getButtonText(): string {
    return this.limit === this.pageLimit
      ? 'app_global_show_less'
      : 'app_global_see_all_carepaths';
  }

  public getPageLowerLimit(): number {
    return this.limit * (this.page - 1);
  }

  public getPageUpperLimit(): number {
    return this.limit * this.page;
  }
}
